import { render, staticRenderFns } from "./CaptainsDeckReview.vue?vue&type=template&id=11be2746&scoped=true&"
import script from "./CaptainsDeckReview.vue?vue&type=script&lang=js&"
export * from "./CaptainsDeckReview.vue?vue&type=script&lang=js&"
import style0 from "./CaptainsDeckReview.vue?vue&type=style&index=0&id=11be2746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11be2746",
  null
  
)

export default component.exports